import gql from 'graphql-tag'

export const CREATE_EXPENSE = gql`
  mutation createExpense($input: CreateExpenseInput!) {
    createExpense(input: $input) {
      expense {
        id
      }
      errors
    }
  }
`

export default {
  CREATE_EXPENSE
}
